<script lang="ts" setup>
import { JointCommittee } from '@/core/collections/contracts-api/joint-committees/joint-committee.interface';
import { PropType } from 'vue';
import { useI18n } from 'vue-i18n';
import Dropdown from './Dropdown.vue';

const { locale } = useI18n();

const emits = defineEmits<{
   (e: 'update:joint-committee-id', value?: number | string): void;
   (e: 'update:joint-committee', value?: JointCommittee): void;
}>();

const props = defineProps({
   jointCommitteeId: { type: [Number, String], default: null },
   name: { type: String, required: true },
   label: { type: String, default: '' },
   disabled: { type: Boolean, default: false },
   required: { type: Boolean, default: false },
   jointCommittees: { type: Array as PropType<Array<JointCommittee>>, default: () => [] },
   errors: { type: Object as PropType<{ [key: string]: string }>, default: () => ({}) },
   uniqueKey: { type: String, default: 'id' },
});

function updateJointCommittee(jointCommitee?: JointCommittee) {
   emits('update:joint-committee-id', getPropertyByKey(props.uniqueKey, jointCommitee));
   emits('update:joint-committee', jointCommitee);
}
</script>

<template>
   <Dropdown
      :model-value="jointCommitteeId"
      :label="label"
      :name="name"
      :disabled="disabled"
      :display-key="'number'"
      :required="required"
      :options="jointCommittees"
      :errors="errors"
      :emit-object="true"
      :auto-select="required"
      :unique-key="uniqueKey"
      :search-on-properties="[`name.${locale}`, 'number']"
      @update:model-value="updateJointCommittee"
   >
      <template #option="{ option }">
         <span class="joint-committee-dropdown__option"> {{ option.number }} - {{ option.name?.[locale] || option.name }} </span>
      </template>
      <template #displayOption="{ option }"> {{ option.number }} - {{ option.name?.[locale] || option.name }}</template>
   </Dropdown>
</template>

<style lang="scss" scoped>
.joint-committee-dropdown__option {
   max-width: toRem(500);
   padding: var(--nxt-gutter-small) 0;
}
</style>
